import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BirthDayList } from '../../models/birthdaylistmodel';
import { DismissBirthdayModalComponent } from '../../components/modals/dismiss-birthday-modal/dismiss-birthday-modal.component';
import { BirthdayDeleteModalComponent } from '../../components/modals/birthday-delete-modal/birthday-delete-modal.component';
import { EditBirthdayComponent } from '../../components/modals/edit-birthday/edit-birthday.component';
import { ModalController } from '@ionic/angular';
import { CurrentValueService } from '../../services/current-value.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-birthday-table',
  templateUrl: './birthday-table.component.html'
})
export class BirthdayTableComponent {

  @Input() birthdayList: BirthDayList[] = [];
  
  @Input() pagination: { totalItems: number, itemsPerPage: number, currentPage: number } = { totalItems: 0, itemsPerPage: 10, currentPage: 1 }

  @Output() onEdit = new EventEmitter<BirthDayList>();
  @Output() onDelete = new EventEmitter<BirthDayList>();
  @Output() pageChange = new EventEmitter<number>();
 
 


  constructor(private modalController: ModalController, private currentValue: CurrentValueService, private router: Router) { }
 
  editBirthday(birthday: BirthDayList) {
    this.onEdit.emit(birthday);
  }

  deleteBirthday(birthday: BirthDayList) {
    this.onDelete.emit(birthday);
  } 

  advancePaymetWillHelper(value: number) {
    if (value === 0) {
      return "NIJE PLAĆEN"
    }
    else if (value === 1) {
      return "PRN"
    }
    else if (value === 2) {
      return "KEŠ"
    }
    else if (value === 3) {
      return "KARTICA"
    }
    else if (value === 4) {
      return "PRN SVE"
    }
    else if (value === 5) {
      return "KEŠ SVE"
    }

    else if (value === 6) {
      return "KARTICA SVE"
    }
  }
  async openEditBirthdayModal(birthdayListList) {
    console.log("Editmethod - birthdayListList", birthdayListList)

    const modal = await this.modalController.create({
      component: EditBirthdayComponent,
      componentProps: { birthdayListList: { ...birthdayListList } },
      cssClass: 'medium-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  async openDeleteBirthDayModal(birthdayListList) {
    const modal = await this.modalController.create({
      component: BirthdayDeleteModalComponent,
      componentProps: { birthdayListList: { ...birthdayListList } },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();

  }
  async openEditDismissBirthdayModal(birthdayListList) {
    const modal = await this.modalController.create({
      component: DismissBirthdayModalComponent,
      componentProps: { birthdayListList: { ...birthdayListList } },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }
  statusCallHelper(value: number) {
    if (value === 0) {
      return "ZAKAZAN"
    }
    else if (value === 1) {
      return "OTKAZAN"
    }
    else if (value === 2) {
      return "RAPITUJE SE"

    }

    else if (value === 3) {
      return "RAZMISLIĆE"

    }
    else if (value === 4) {
      return "POZVATI GA"

    }
      else if (value === 5) {
      return "REZERVISAN"

    }

  }
  blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }

  openBirthdayDetails(b: any) {
    this.currentValue.set('birthday', b);
    this.router.navigate(['/admin/birthday-details', b.visitorId, 'birthdays', b.id]);
  }
getLocalTimeFromServer(serverTime: string | Date): string {
  if (!serverTime) return '';

  let utcString = typeof serverTime === 'string' ? serverTime : serverTime.toString();

 
  if (!utcString.endsWith('Z')) {
    utcString += 'Z';
  }

  const date = new Date(utcString);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

}
